<mat-form-field class="input-container" [formGroup]="group" (click)="picker.open()">
  <input matInput [min]="min" [max]="max"
                  [matDatepicker]="picker"
                  [formControl]="control"
                  [placeholder]="placeHolder" readonly="true">
  <mat-error *ngIf="control?.invalid && control?.touched">Field required</mat-error>
  <mat-datepicker-toggle matSuffix [for]="picker">
    <mat-icon class="icon" matDatepickerToggleIcon>calendar_today</mat-icon>
  </mat-datepicker-toggle>
  <mat-datepicker #picker touchUi
                  [startView]="startView"
                  (monthSelected)="chosenMonthHandler($event, picker)"
                  disabled="false">
  </mat-datepicker>
  <mat-hint [hidden]="noHint" align="end">DD/MM/YYYY</mat-hint>
</mat-form-field>